import React from 'react';
import PropTypes from 'prop-types';

// Components
import Icon from '@src/components/Icon';

// Constants
import { ENTITY_CATEGORY } from '@src/constants/Entities';

// Shared Components
import styles from './EntityCategoryLabel.scss';

export default function EntityCategoryLabel({ category }) {
  let iconType = null;
  let label = null;

  switch (category) {
    case ENTITY_CATEGORY.SYSTEM:
      iconType = 'entity-category-public';
      label = 'Public';
      break;

    case ENTITY_CATEGORY.DOMAIN:
      iconType = 'entity-category-bot';
      label = 'Local';
      break;

    case ENTITY_CATEGORY.DEPRECATED:
      iconType = 'entity-category-deprecated';
      label = 'Local (Other Bot)';
      break;

    default:
      break;
  }

  return (
    <div className={`${styles.entityCategoryLabel}`}>
      <Icon iconType={iconType} size={20} />
      &nbsp;&nbsp;{label}
    </div>
  );
}

EntityCategoryLabel.propTypes = {
  category: PropTypes.number,
};
